import { loadTracehash } from './hash'
import { loadTraceIframe } from './iframe'
import md5 from 'md5'

// 跨浏览器事件侦听
export const utils = {
  addEvent: (function () {
    if (document.attachEvent) {
      return function (ele, type, func) {
        ele.attachEvent('on' + type, func);
      };
    } else if (document.addEventListener) {
      return function (ele, type, func) {
        ele.addEventListener(type, func, false);
      };
    }
  })(),
};

// 传参path
export function getPath(res) {
  let path = res || window.location.hash || ''
  if (path.indexOf('#') > -1) {
    path = path.substring(path.indexOf('#') + 1, path.length);
  }

  if (path.indexOf('?') > -1) {
    path = path.substring(0, path.indexOf('?'));
  }
  return path
}

// 一些手动输入错误的路由禁止埋点
export const errorPath = (path) => {
  const obj = {
    '': true,
    undefined: true,
    '/': true,
  }
  if (path.indexOf('index') > -1 && path.indexOf('homepa') > -1) {
    if (path !== '/index/homepage' && path !== '/index/homepage#hasLogin') {
      return false
    }
  }

  if (obj[path] || path.indexOf('https') > -1 || path.indexOf('%') > -1) {
    return false
  }


  if (path.indexOf('orderLi') > -1 && path !== '/orderList') {
    return false
  }

  return true
}

const getUserId = ({ userId, localIdName = 'ShipperInfo' }) => {
  const ShipperInfo = (localStorage.getItem(localIdName) && JSON.parse(localStorage.getItem(localIdName))) || {}
  const traceUserId = localStorage.getItem('traceUserId')
  if (userId && userId !== 'null' && userId !== 'undefined') {
    return userId
  }
  if (traceUserId && traceUserId !== 'null' && traceUserId !== 'undefined') {
    return traceUserId
  }
  if (ShipperInfo.partyId && ShipperInfo.partyId !== 'null' && ShipperInfo.partyId !== 'undefined') {
    return ShipperInfo.partyId
  }
  return ''
}
// 启动应用
export function openWeb(props = {}) {
  const path = getPath()
  const { sourceCode, title = '启动应用', udid } = props
  window.TraceService && window.TraceService.tpLaunch({
    userId: '',
    path,
    sourceCode,
    title,
    udid
  })
}

// 关闭应用
export function closeWeb(props = {}) {
  const path = getPath()
  const { sourceCode, title = '关闭应用', udid } = props
  window.TraceService && window.TraceService.tpClose({
    userId: getUserId(props) || '',
    path,
    sourceCode,
    title,
    udid
  })
}

// 点击埋点
export function tpEvent(props) {
  const { evtType = 'mousedown', udid } = props
  const attr = 'tp-data';
  //事件可根据情况自定义
  utils.addEvent(document, evtType, function (evt) {
    const target = evt.srcElement || evt.target;

    // name来源
    const nameSource = {
      BUTTON: true, // BUtton 按钮
      A: true, // a标签
    };

    // 获取name
    let name;
    // 如果有设置name属性
    if (target && target.parentNode && target.hasAttribute(attr)) {
      name = target.getAttribute(attr);
    } else if (target && target.innerText && target.innerText !== '') {
      // 如果是枚举里面的来源并且里面有文案
      if (
        nameSource[evt.path && evt.path[1] && evt.path[1].nodeName] ||
        nameSource[target.nodeName]
      ) {
        name = evt.srcElement.innerText;
      }
    }

    if (name) {
      const path = getPath()
      if (!path || path == '') {
        return
      }
      setTimeout(() => {
        window.TraceService && window.TraceService.tpEvent({
          path,
          userId: getUserId(props),
          name,
          udid
        });
      }, 600)
    }
  });
}

// 自定义点击埋点
export function tpEventAuto(props) {
  const { udid, sourceCode, start } = props
  window.tpEvent = (name, extend = {}) => {
    const path = getPath()
    setTimeout(() => {
      window.TraceService && window.TraceService.tpEvent({
        path,
        userId: getUserId(props),
        sourceCode,     //需要动态切换时传入，默认不传
        start,        //时间戳
        name,
        udid,
        extend
      })
    }, 100)
  }
}

const getOldPath = () => {
  let oldTrace = sessionStorage.getItem('oldTrace')
  oldTrace = oldTrace ? JSON.parse(oldTrace) : {}
  if (!oldTrace.path) {
    oldTrace.path = getPath()
  }
  return oldTrace
}

// 是否停留埋点
export function tpDurationLoad(props) {
  const { udid, sourceCode } = props
  setTimeout(() => {
    window.TraceService && window.TraceService.tpDuration({
      ...getOldPath(),
      userId: getUserId(props),
      udid,
      sourceCode,
      extend: { desc: "tpheart", time: 1 }
    }, 'fetch');
  }, 500)
}

// 执行路由埋点
export function loadTrace(props) {
  const path = getPath()
  const { udid, sourceCode, start } = props
  // 执行当前页面的路由埋点
  window.TraceService && window.TraceService.trace({
    userId: getUserId(props),
    path,
    sourceCode,
    udid,
    fromPath: getOldPath().path
  });
  // 保存当前路由的时间和path,
  sessionStorage.setItem('oldTrace', JSON.stringify({
    start,
    path
  }))
}

// 页面停留时长埋点
export function tpDuration(props) {
  const { udid, sourceCode } = props
  // 先执行上个页面的停留埋点
  window.TraceService && window.TraceService.tpDuration({
    userId: getUserId(props),
    sourceCode,
    udid,
    ...getOldPath(),
  });
}

// 页面停留时长埋点
export function tpDurationFetch(props) {
  const { udid, sourceCode } = props
  window.TraceService && window.TraceService.tpDuration(
    {
      userId: getUserId(props),
      udid,
      sourceCode,
      ...getOldPath(),
    },
    'fetch',
  );
}

// 流程时长埋点
export function tpFlow(props) {
  const { udid, sourceCode, start } = props
  window.toFlow = (name) => {
    const path = getPath()
    window.TraceService && window.TraceService.tpFlow({
      path,
      userId: getUserId(props),
      sourceCode,     //需要动态切换时传入，默认不传
      start,        //时间戳
      name,
      udid,
    })
  }
}


export function loadTraceServer(props) {
  const { sourceCode, type, isPro, userId } = props
  window.sourceCode = sourceCode;
  // 首次加载引入埋点链接
  (function initScript() {
    const src = isPro
      ? `https://v1.tf56.com/s/staticWeb/trace-service.js?sourceCode=${sourceCode}&userId=${getUserId(props) || userId}`
      : `https://v1test.tf56.com/s/staticWeb/trace-service.js?sourceCode=${sourceCode}&userId=${getUserId(props) || userId}`;

    // 动态加载TraceService插件
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src
    document.querySelector('head').appendChild(script);

  })()

  let udid;
  // 解决关闭浏览器或者关掉电脑没有停留
  if (!localStorage.getItem('udid')) {
    udid = `${Math.floor(Math.random() * 1000)}${sourceCode}${new Date().getTime()}`
    localStorage.setItem('udid', md5(udid))
  } else {
    udid = localStorage.getItem('udid')
  }

  type === 'iframe' && loadTraceIframe({ ...props, udid })
  type === 'hash' && loadTracehash({ ...props, udid })
}


// WEBPACK FOOTER //
// ./src/tf-traceService/index.js